<template>
  <div class="Home">
    <div class="nei_container">
      <div class="text_c">
        <div class="index_title">
          <div class="index_ts">业务介绍</div>
        </div>
        <span class="index_tp">Business Introduction</span>
      </div>
      <ul class="index_bus_ul clearfix">
        <li @click="goToPage('/shencha')">
          <div class="li_con">
            <div class="img">
              <img src="../assets/sc.png" />
              <div class="li_b">施工图审查</div>
              <div class="li_m">
                <div class="li_mcc">
                  <div class="li_mc">
                    <div class="li_mt">施工图审查</div>
                    <div class="li_ma">查看详情&gt;</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li @click="goToPage('/cl')">
          <div class="li_con">
            <div class="img">
              <img src="../assets/gc.png" />
              <div class="li_b">办事指南</div>
              <div class="li_m">
                <div class="li_mcc">
                  <div class="li_mc">
                    <div class="li_mt">办事指南</div>
                    <div class="li_ma">查看详情&gt;</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li @click="goToPage('/bim')">
          <div class="li_con">
            <div class="img">
              <img src="../assets/bim.png" />
              <div class="li_b">建筑信息模型(BIM)咨询服务</div>
              <div class="li_m">
                <div class="li_mcc">
                  <div class="li_mc">
                    <div class="li_mt">建筑信息模型(BIM)咨询服务</div>
                    <div class="li_ma">查看详情&gt;</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li  @click="goToPage('/qz')">
          <div class="li_con">
            <div class="img">
              <img src="../assets/qzz.jpg" />
              <div class="li_b">PSee签章</div>
              <div class="li_m">
                <div class="li_mcc">
                  <div class="li_mc">
                    <div class="li_mt">PSee签章</div>
                    <div class="li_ma">查看详情&gt;</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li  @click="goToPage('/ct')">
          <div class="li_con">
            <div class="img">
              <img src="../assets/ct.jpg" />
              <div class="li_b">PSee拆图</div>
              <div class="li_m">
                <div class="li_mcc">
                  <div class="li_mc">
                    <div class="li_mt">PSee拆图</div>
                    <div class="li_ma">查看详情&gt;</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="nei_container">
      <div class="text_c">
        <div class="index_title">
          <div class="index_ts">设计依据</div>
        </div>
        <span class="index_tp">Design Basis</span>
      </div>
      <ul class="index_bus_ul clearfix">
        <li @click="goToPage('/jzz')">
          <div class="li_con">
            <div class="img">
              <img src="../assets/sj.jpg" />
              <div class="li_b">建筑</div>
              <div class="li_m">
                <div class="li_mcc">
                  <div class="li_mc">
                    <div class="li_mt">建筑</div>
                    <div class="li_ma">查看详情&gt;</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li @click="goToPage('/jgg')">
          <div class="li_con">
            <div class="img">
              <img src="../assets/jg.jpg" />
              <div class="li_b">结构</div>
              <div class="li_m">
                <div class="li_mcc">
                  <div class="li_mc">
                    <div class="li_mt">结构</div>
                    <div class="li_ma">查看详情&gt;</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li @click="goToPage('/gpss')">
          <div class="li_con">
            <div class="img">
              <img src="../assets/gps.jpg" />
              <div class="li_b">给排水</div>
              <div class="li_m">
                <div class="li_mcc">
                  <div class="li_mc">
                    <div class="li_mt">给排水</div>
                    <div class="li_ma">查看详情&gt;</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li @click="goToPage('/ntt')">
          <div class="li_con">
            <div class="img">
              <img src="../assets/nt.png" />
              <div class="li_b">暖通</div>
              <div class="li_m">
                <div class="li_mcc">
                  <div class="li_mc">
                    <div class="li_mt">暖通</div>
                    <div class="li_ma">查看详情&gt;</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li @click="goToPage('/dqq')">
          <div class="li_con">
            <div class="img">
              <img src="../assets/dq.jpg" />
              <div class="li_b">电气</div>
              <div class="li_m">
                <div class="li_mcc">
                  <div class="li_mc">
                    <div class="li_mt">电气</div>
                    <div class="li_ma">查看详情&gt;</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
    }
  },
  mounted(){
    console.log('$router.path:',this.$route.path)
  },
  methods:{
    goToPage(path){
      this.$router.push({ path});
    }
  }
}
</script>
<style lang="scss" scoped>
.Home {
  .nei_container {
    margin: 25px auto;
    width: 1200px;
    .text_c {
      text-align: center;
    }
    .index_tp {
      display: inline-block;
      font-size: 18px;
      background: #fff;
      padding: 0px 50px;
      position: relative;
      z-index: 1;
      color: #ccc;
      margin-top: -5px;
    }
    .index_title {
      font-size: 30px;
      line-height: 50px;
      position: relative;
      text-align: center;
      &::before {
        display: block;
        height: 1px;
        top: 50%;
        width: 100%;
        left: 0px;
        background: #d7d7d7;
        position: absolute;
        content: "";
      }
      .index_ts {
        display: inline-block;
        font-size: 24px;
        background: #fff;
        padding: 0px 50px;
        position: relative;
        z-index: 1;
      }
    }
  }
  .index_bus_ul {
    margin: 15px -15px;
    li {
      width: 33.33333%;
      float: left;
      cursor: pointer;
      .li_con {
        margin: 15px;
        .img {
          border-radius: 10px;
          overflow: hidden;
          position: relative;
          img {
            display: block;
            width: 100%;
            height: 160px;
          }
          .li_b {
            height: 40px;
            line-height: 40px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            position: absolute;
            bottom: 0;
            left: 0px;
            width: 100%;
            background: rgba(29, 89, 144, 0.8);
            text-align: center;
            color: #fff;
            font-size: 16px;
            transition: all 0.2s;
            font-weight: 700;
          }
          .li_m {
            transition: all 0.2s;
            line-height: 42px;
            position: absolute;
            bottom: -200%;
            left: 0px;
            width: 100%;
            background: rgba(29, 89, 144, 0.8);
            text-align: center;
            color: #fff;
            font-size: 16px;
            height: 100%;
            .li_mcc {
              position: relative;
              height: 100%;
              .li_mc {
                height: 70px;
                top: 50%;
                margin-top: -35px;
                position: absolute;
                width: 100%;
                .li_mt {
                  font-size: 24px;
                }
                .li_ma {
                  width: 120px;
                  height: 28px;
                  line-height: 28px;
                  margin: 0 auto;
                  background: rgba(255, 255, 255, 0.3);
                }
              }
            }
          }
        }
      }

      .img:hover {
        .li_b {
          bottom: -200%;
        }
        .li_m {
          bottom: 0;
        }
      }
    }
  }
}
</style>